<template>
    <div>
        <div @click="selctCurProd(prod)" class="prod_item" :class="{ 'slimMode': isSlimMode() }">
            <div class="img_container">
                <img v-if="image != null && hasImage" :src="image" @error="() => this.hasImage = false">
                <img v-else :src="noImageSrc">
            </div>
            <div class="name_container">
                <div class="container">
                    <span class="name" v-text="getProductLanguage(prod, 'productName')"></span>
                </div>
            </div>
            <div class="description_container" v-if="prod.productDescription">
                <span class="description" v-text="getProductLanguage(prod, 'productDescription')"></span>
            </div>
            <div v-else></div>
            <div class="price_container">
                <div class="container">
                    <template v-if="checkSignalsDiscount()">
                        <div class="price_row">
                            <span class="from" v-if="exibApartir()">{{ getString('a_partir_de_gom') }}</span>
                            <span class="price diff_price">{{ formatMoney(fullMinPrice) }}</span>
                        </div>
                        <span class="price" :class="{ 'bold': useBoldPrice() }">{{ formatMoney(minPrice) }}</span>
                    </template>
                    <template v-else>
                        <div class="price_row">
                            <span class="from" v-if="exibApartir()">{{ getString('a_partir_de_gom') }}</span>
                            <span class="price" :class="{ 'bold': useBoldPrice() }">{{ formatMoney(minPrice) }}</span>
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <div class="overlay" v-if="showOverlay" @click="cancelSuggestModal()"></div>
        <Transition name="bounce">
            <SuggestionsModalGom v-if="showSuggestionsModal" :suggestData="suggestData"
                :suggestModalDepth="suggestModalDepth" @suggestChoose="suggestChoose">
            </SuggestionsModalGom>
        </Transition>
    </div>
</template>

<script>
import LocaleController from '@/assets/controllers/LocaleController'
import Util from '@/assets/libs/util'
import ProductController from '@/assets/controllers/ProductController'
import MinPriceController from '@/assets/controllers/MinPriceController'
import SuggestionsModalGom from '@/components/SuggestionsModalGom'
import eventModule from '@/assets/libs/eventModule'

export default {
    name: 'ProductCard',
    props: [
        'name',
        'image',
        'price',
        'prod',
        'blockProds'
    ],
    components: {
        SuggestionsModalGom
    },
    data () {
        return {
            suggestData: {},
            suggestModalDepth: null,
            showSuggestionsModal: false,
            showOverlay: false,
            hasImage: true,
            noImageSrc: null,
            signalsDiscount: Util.getLocalConfigs('signalsDiscount'),
            junk: require('../../static/icons/junk-icon.png'),
            minPrice: 0,
            fullMinPrice: 0,
            removeProdutoSugestaoAutomatico: Util.getLocalConfigs('removeProdutoSugestaoAutomatico')
        }
    },
    created () {
        this.calculateMinPrice(this.prod)
        eventModule.$on('forceUpdate', this.forceUpdate)
    },
    beforeDestroy () {
        eventModule.$off('forceUpdate', this.forceUpdate)
    },
    mounted () {
        this.noImageSrc = Util.getConfigImage('noImage') || this.junk
    },
    methods: {
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        },
        forceUpdate: function () {
            this.$forceUpdate()
        },
        getString: function (key) {
            return LocaleController.getString(key)
        },
        cutText: function (text) {
            if (text.length > 100 && !this.showText) {
                return text.substring(100, 0) + this.getString('veja_mais')
            }
            return text
        },
        isSlimMode: function () {
            return Util.isSlimMode()
        },
        useBoldPrice: function () {
            return Util.useBoldPrice()
        },
        suggestChoose: async function (prod) {
            this.suggestModalDepth++
            await this.closeSuggestModal()
            this.selctCurProd(prod)
        },
        openSuggestModal: function () {
            this.showSuggestionsModal = true
            this.showOverlay = true
        },
        closeSuggestModal: function () {
            let self = this
            return new Promise(function (resolve, reject) {
                try {
                    self.showSuggestionsModal = false
                    resolve(true)
                } catch (e) {
                    reject(e)
                }
            })
        },
        cancelSuggestModal: function () {
            this.suggestModalDepth = null
            this.showOverlay = false
            this.closeSuggestModal()
        },
        exibApartir: function () {
            return (Util.exibApartir() && Util.variablePrice(this.prod))
        },
        formatMoney: function (price) {
            return Util.formatMoney(price)
        },
        selctCurProd: async function (prod) {
            let productSuggestion = prod.productSuggestion || []
            let requestSuccess = productSuggestion != null && typeof productSuggestion === 'object'
            let productHasSuggestions = (productSuggestion.suggestions && productSuggestion.suggestions[prod.productCode] && productSuggestion.suggestions[prod.productCode].length > 0)
            let hasSuggestionsForCurrentDepth = false
            let suggestedRaw = []

            if (requestSuccess && productHasSuggestions) {
                suggestedRaw = productSuggestion.suggestions[prod.productCode]
                hasSuggestionsForCurrentDepth = this.checkSuggestionsForDepth(suggestedRaw)
            }

            if (hasSuggestionsForCurrentDepth) {
                this.handleProductSuggestion(prod, suggestedRaw)
            } else {
                this.selectCurProd(prod)
            }
        },
        checkSuggestionsForDepth: function (suggestedRaw) {
            let currentDepth = this.suggestModalDepth
            let blockProds = this.blockProds || []
            let hourlyUnavailableProds = Util.getLocalVar('hourlyUnavailableProds') || []

            let suggestedFlavours = []
            let suggestedSizes = []
            let suggestedCombos = []
            suggestedRaw.forEach(element => {
                let prodIsNotBlocked = blockProds.find(blockProd => blockProd === element.productSuggestion) === undefined &&
                    hourlyUnavailableProds.find(prod => prod === element.productSuggestion) === undefined

                if (element.suggestionType === 4 && prodIsNotBlocked) {
                    suggestedFlavours.push(element)
                } else if (element.suggestionType === 3 && prodIsNotBlocked) {
                    suggestedSizes.push(element)
                } else if (element.suggestionType === 5 && prodIsNotBlocked) {
                    suggestedCombos.push(element)
                }
            })

            let anySuggestedFlavour = suggestedFlavours.length > 0 &&
                !(suggestedFlavours.length === 1 && suggestedFlavours[0].productSuggestion === suggestedFlavours[0].productCode)
            let anySuggestedSize = suggestedSizes.length > 0 &&
                !(suggestedSizes.length === 1 && suggestedSizes[0].productSuggestion === suggestedSizes[0].productCode)
            let anysuggestedCombo = suggestedCombos.length > 0 &&
                !(suggestedCombos.length === 1 && suggestedCombos[0].productSuggestion === suggestedCombos[0].productCode)

            let depthZeroConditions = (currentDepth === null || currentDepth === 0) && (anySuggestedFlavour || anySuggestedSize || anysuggestedCombo)
            let depthOneConditions = currentDepth === 1 && (anySuggestedSize || anysuggestedCombo)
            let depthTwoConditions = currentDepth === 2 && anysuggestedCombo

            return depthZeroConditions || depthOneConditions || depthTwoConditions
        },
        handleProductSuggestion: function (clickedProduct, suggestedRaw) {
            let suggestedFlavours = []
            let suggestedSizes = []
            let suggestedCombos = []

            // Separa as sugestões de acordo com o tipo
            suggestedRaw.forEach(element => {
                let prod = ProductController.getProdItem(element.productSuggestion)

                if (prod) {
                    let hourlyUnavailableProds = Util.getLocalVar('hourlyUnavailableProds') || []
                    let prodIsNotBlocked = hourlyUnavailableProds.find(element => element === prod.productCode) === undefined
                    if (element.suggestionType === 4 && prodIsNotBlocked) {
                        suggestedFlavours.push(prod)
                    } else if (element.suggestionType === 3 && prodIsNotBlocked) {
                        suggestedSizes.push(prod)
                    } else if (element.suggestionType === 5 && prodIsNotBlocked) {
                        suggestedCombos.push(prod)
                    }
                }
            })
            // Caso o produto já clicado seja o único de algum array de sugestões, limpa aquele array
            if (suggestedFlavours.length === 1 && suggestedFlavours[0].productCode === clickedProduct.productCode) {
                suggestedFlavours = []
            }

            if (suggestedSizes.length === 1 && suggestedSizes[0].productCode === clickedProduct.productCode) {
                suggestedSizes = []
            }

            if (suggestedCombos.length === 1 && suggestedCombos[0].productCode === clickedProduct.productCode) {
                suggestedCombos = []
            }

            // Verifica se o produto originalmente clicado precisa ser inserido em algum grupo de sugestões
            if (!this.removeProdutoSugestaoAutomatico) {
                if (suggestedFlavours.length > 0) {
                    let hasClickedProduct = suggestedFlavours.find((element) => element.productCode === clickedProduct.productCode)
                    if (!hasClickedProduct) suggestedFlavours.unshift(clickedProduct)
                }

                if (suggestedSizes.length > 0) {
                    let hasClickedProduct = suggestedSizes.find((element) => element.productCode === clickedProduct.productCode)
                    if (!hasClickedProduct) suggestedSizes.unshift(clickedProduct)
                }

                if (suggestedCombos.length > 0) {
                    let hasClickedProduct = suggestedCombos.find((element) => element.productCode === clickedProduct.productCode)
                    if (!hasClickedProduct) suggestedCombos.unshift(clickedProduct)
                }
            }

            // Se for o primeiro modal de sugestão a ser aberto para esse produto, inicializa o contador suggestModalDepth
            // de acordo com o nível da primeira sugestão a ser exibida
            if (this.suggestModalDepth === null) {
                if (suggestedFlavours.length === 0 && suggestedSizes.length === 0) {
                    this.suggestModalDepth = 2
                } else if (suggestedFlavours.length === 0) {
                    this.suggestModalDepth = 1
                } else {
                    this.suggestModalDepth = 0
                }
            }

            this.suggestData = {
                flavours: this.suggestModalDepth === 0 ? suggestedFlavours : [],
                sizes: this.suggestModalDepth <= 1 ? suggestedSizes : [],
                combos: suggestedCombos
            }

            let hasAnyAvailableSuggestion = this.suggestData.flavours.length > 0 || this.suggestData.sizes.length > 0 ||
                this.suggestData.combos.length > 0

            if (hasAnyAvailableSuggestion) {
                this.openSuggestModal()
            } else {
                this.selectCurProd(clickedProduct)
            }
        },
        selectCurProd: function (prod) {
            this.suggestModalDepth = null
            this.showOverlay = false
            this.$emit('selectCurprod', prod)
        },
        getMinPrice: function (prod) {
            return MinPriceController.getMinPrice(prod)
        },
        calculateMinPrice: function (prod) {
            this.minPrice = MinPriceController.getMinPrice(prod)
            this.minPrice = parseFloat(this.minPrice.replace('R$', '').replace(',', '.'))
            this.fullMinPrice = parseFloat(prod.calculatedFullMinPrice)
        },
        checkSignalsDiscount: function () {
            return this.signalsDiscount && (((this.minPrice + 1) < this.fullMinPrice))
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.prod_item {
    position: relative;
    background-color: @white;
    padding: 0;
    text-align: center;
    margin: 10px;
    border: 3px solid @disabled-color;
    border-radius: 25px;
    display: grid;
    grid-template-rows: 240px 60px auto 80px;
    height: -webkit-fill-available;
    /* Fallback para WebViews mais antigos */
    height: 100%;
    min-height: 380px;

    .container {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: calc(100% - 30px);
        padding: 0 15px;
    }

    &.slimMode {
        box-shadow: unset;
        grid-template-rows: 160px 50px 40px;
    }
}

.img_container {
    img {
        object-fit: cover;
        width: 100%;
        height: 100%;
        display: block;
        border-top-left-radius: 25px;
        border-top-right-radius: 25px;
    }
}

.name_container {
    position: relative;

    .name {
        font-family: @default-font;
        font-size: 1.3rem;
        display: block;
        max-width: 100%;
        // text-transform: uppercase;
        text-align: center;
        margin: auto;
        padding: 0;
    }
}

.description_container {
    padding: 0 5px;
    max-height: 60px;
    min-height: 0;

    .description {
        font-size: 1.1rem;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        line-height: 1.3;
    }
}

.price_container {
    position: relative;
    height: 80px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    .container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 3px;

        .price_row {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            gap: 5px;
        }

        .from {
            font-size: 20px;
            color: @black;
            line-height: 1;
        }

        .price {
            font-family: @default-font;
            font-size: 22px;
            color: var(--price-font-color);
            margin: 0;
            line-height: 1;

            &.diff_price {
                text-decoration: line-through;
                color: @disabled-color;
                font-size: 20px;
            }
        }
    }

    .bold {
        font-weight: bold;
    }
}

.overlay {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 2;
}

@media (min-width: 699px) and (max-width: 1025px) {

    //@tablet
    .prod_item {
        margin: 10px;
        grid-template-rows: 160px 45px auto 65px;
        min-height: 270px;

        .container {
            width: calc(100% - 30px);
            padding: 0 15px;
        }

        &.slimMode {
            box-shadow: unset;
            grid-template-rows: 130px 45px 35px;
            min-height: 210px;
        }
    }

    .img_container {
        img {
            height: 100%;
            // margin-top: 10px;
        }
    }

    .name_container {
        .name {
            font-size: 1rem;
        }
    }

    .price_container {
        height: 50px;

        .container {
            .price {
                font-size: 18px;
            }
            .price_row {
                gap: 2px;

                .from {
                    font-size: 16px;
                }

                .price {
                    font-size: 18px;
                }

                .price.full-min-price {
                    font-size: 16px;
                }
            }
        }
    }

    .description_container {
        padding: 0 5px;
        max-height: 50px;

        .description {
            font-size: 0.9rem;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            line-height: 1.2;
        }
    }
}

@media (max-width: 698px) {

    // Gertec SK210
    .prod_item {
        margin: 5px;
        grid-template-rows: 120px 40px auto 50px;
        border-width: 1px;
        border-radius: 15px;
        min-height: 230px;

        &.slimMode {
            box-shadow: unset;
            grid-template-rows: 110px 40px 50px;
            min-height: 180px;
        }
    }

    .img_container {
        img {
            height: 100%;
            // margin-top: 5px;
            border-top-left-radius: 15px;
            border-top-right-radius: 15px;
        }
    }

    .name_container {
        .container {
            .name {
                padding: 5px;
                font-size: .9em;
            }
        }
    }

    .price_container {
        height: 42px;

        .container {
            .price {
                font-size: 14px;
            }

            .price_row {
                gap: 2px;
                width: 100%;
                flex-direction: column;

                .from {
                    font-size: 12px;
                }

                .price {
                    font-size: 14px;
                }

                .price.diff_price{
                    font-size: 12px !important;
                }
            }
        }
    }

    .description_container {
        padding: 0 3px;
        max-height: 40px;

        .description {
            font-size: 11px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            line-height: 1.2;
        }
    }
}

@media (orientation: landscape) {
    .prod_item {
        margin: 5px;
        grid-template-rows: 150px 45px min-content auto;
        min-height: 270px;
        border-radius: 12px;
        border: solid 1px rgba(3, 0, 79, 0.4);

        .container {
            width: calc(100% - 30px);
            padding: 0 15px;
        }

        &.slimMode {
            box-shadow: unset;
            grid-template-rows: 130px 45px 35px;
            min-height: 210px;
        }
    }

    .img_container {
        img {
            border-top-left-radius: 12px;
            border-top-right-radius: 12px;
            height: 100%;
            // margin-top: 10px;
        }
    }

    .name_container {
        align-self: center;
        height: 100%;

        .name {
            font-size: 1rem;
        }
    }

    .price_container {
        height: 100%;

        .from {
            font-size: 16px;
            margin-bottom: 1px;
        }

        .price {
            font-size: 18px;
        }

        .price.full-min-price {
            font-size: 16px;
        }
    }

    .description_container {
        padding: 0 5px;
        max-height: 50px;
        min-height: 0;

        .description {
            font-size: 0.9rem;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            line-height: 1.2;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ProductCardGom.vue